import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Attend } from '../Models/attend';

import 'rxjs/add/operator/toPromise';
import 'rxjs';
import { Observable } from 'rxjs';


@Injectable()
export class AttendStaffService {

  private headers = new Headers({'Content-Type': 'application/json'});
  private attendsUrl = 'api/attendances/staffs';  // URL to web api

  constructor(private http: Http) { }

  // Check out api, update an already attendance end time
  addCheckOut(attend: Attend) {
    return this.http
      .put(this.attendsUrl, JSON.stringify(attend), {headers: this.headers})
      .map(data => data.json())
  }
  // Check in api, create new attendance with start time
  addCheckIn(attend: Attend) {
    return this.http
      .post(this.attendsUrl, JSON.stringify(attend), {headers: this.headers})
      .map(res => res.json().data as Attend)
  }

}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/Service/attend-staff.service.ts